import { useEffect, useRef, useState } from "react";

/**
 * useIdleTimer - fires `onIdle` after `timeout` ms of no user activity.
 * Returns { isIdle, reset() } so consumer can render screensaver overlay.
 */
export default function useIdleTimer({ timeout = 45000, enabled = true } = {}) {
    const [isIdle, setIsIdle] = useState(false);
    const timerRef = useRef(null);

    const reset = () => {
        setIsIdle(false);
        if (timerRef.current) clearTimeout(timerRef.current);
        if (!enabled) return;
        timerRef.current = setTimeout(() => setIsIdle(true), timeout);
    };

    useEffect(() => {
        if (!enabled) {
            if (timerRef.current) clearTimeout(timerRef.current);
            setIsIdle(false);
            return;
        }
        const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
        const handler = () => reset();
        events.forEach((ev) => window.addEventListener(ev, handler, { passive: true }));
        reset();
        return () => {
            events.forEach((ev) => window.removeEventListener(ev, handler));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, timeout]);

    return { isIdle, reset };
}
